export default __webpack_public_path__ + "static/media/an9.5a6bfa19.jpg";